export interface Invoice {
  uuid?: string;
  number: string;
  debtorTaxCodePrefix: string;
  debtorTaxCode: string;
  debtorBusinessName: string;
  debtorCertifiedEmail?: string;
  debtorContactFirstName: string;
  debtorContactLastName: string;
  debtorContactEmail: string;
  debtorContactPhone: string;
  status?: InvoiceStatus;
  minimumBid: number;
  amount: number;
  fileKey: number;
  issueDate: Date;
  dueDate: Date;
  averagePaymentDelay: number;
  sellerTaxCodePrefix?: string;
  attachments?: Attachment[];
  updatedAt?: Date;
  createdAt?: Date;
  invoiceFile?: File;
  bids: InvoiceBidsPrice;
  installments?: Installment[];
  fromXml: boolean;
}

export interface Attachment {
  id?: number;
  file?: File;
  name: string;
  attachmentType: AttachmentType;
  expirationDate?: Date;
  extraData?: string;
  awsKey: string;
  createdAt: string;
  updatedAt: string;
  toDelete?: boolean;
  status?: DocumentStatus;
  otherDocumentNotes?: string;
}

export enum DocumentStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export enum AttachmentType {
  delivery_note = 'DELIVERY_NOTE', // Documento di trasporto (DDT)
  delivery_note_carrier = 'DELIVERY_NOTE_CARRIER', // Documento di trasporto (DDT) firmato dal vettore
  customer_order = 'CUSTOMER_ORDER', // Ordine cliente
  supply_contract = 'SUPPLY_CONTRACT', // Contratto di fornitura
  sdi_delivery_receipt = 'SDI_DELIVERY_RECEIPT', // Ricevuta invio SDI
  xml_invoice = 'XML_INVOICE', // Fattura elettronica in formato xml
  client_ledger = 'CLIENT_LEDGER', // Partitario cliente
  other = 'OTHER', // Altro
  customer_order_confirmation = 'CUSTOMER_ORDER_CONFIRMATION', // Conferma ordine
  work_progress = 'WORK_PROGRESS', // Sal - Stato avanzamento lavori
  release_guarantee_letter = 'RELEASE_GUARANTEE_LETTER', // Lettera di svincolo Factor
  customer_email_exchange = 'CUSTOMER_EMAIL_EXCHANGE', // Scambio email con il cliente
}

export interface InvoiceList {
  page: number;
  pageSize: number;
  pageCount: number;
  totalItems: number;
  data: Invoice[];
}

export enum InvoiceStatus {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
}

export interface InvoiceBidsPrice {
  minimumBid: number;
  suggestedBid: number;
  maximumBid: number;
}

export interface Installment {
  id?: number;
  dueDate: Date;
  amount: number;
  createdAt?: Date;
  updatedAt?: Date;
}
